module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-non-bodymatter element-container-single element-type-epigraph element-with-heading",
    attrs: {
      "id": "epigraph-2"
    }
  }, [_c('div', {
    staticClass: "heading heading-container-single heading-size-full heading-format-full heading-alignment-flexible heading-without-image"
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "element-title case-upper"
  }, [_vm._v("ABOUT THE AUTHOR")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "epigraph-2-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width epigraph-content"
  }, [_vm._v("Kevin Ikenberry is a lifelong space geek and retired Army officer. As an adult, he managed the U.S. Space Camp program and served in space operations before Space Force was a thing. He’s an international bestselling science fiction author and renowned writing instructor, which is pretty cool because he never imagined being either one of those—he still wants to be an astronaut.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq epigraph-content"
  }, [_vm._v("Kevin’s debut novel, "), _c('i', [_vm._v("Sleeper Protocol")]), _vm._v(", was hailed by "), _c('i', [_vm._v("Publishers Weekly")]), _vm._v(" as “an emotionally powerful debut.” His over twenty novels science fiction novels include "), _c('i', [_vm._v("The Crossing")]), _vm._v(", "), _c('i', [_vm._v("Vendetta Protocol, Eminence Protocol, Runs in the Family, Peacemaker, Honor the Threat, Stand or Fall, Fields of Fire, ")]), _vm._v("and "), _c('i', [_vm._v("Harbinger")]), _vm._v(". Kevin is an active member of the International Association of Science Fiction and Fantasy Authors, International Thriller Writers, and SIGMA—the science fiction think tank. Kevin continues to work with space every day and lives in Colorado with his family.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c6b5204","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/about-the-author-2.vue
// module id = 84
// module chunks = 0